<template>
    <section class="target-main">
        <div class="target-layout">
            <TabContainer :tabs="tabs" :activeTab.sync="activeTab">
                <template #default="{ activeTab: currentTab }">
                    <!-- 준수기준 관리 탭 -->
                    <div v-show="currentTab === 'compliance'" class="panel">
                        <div class="panel-body">
                            <ComplianceManagement :is-active="isActive && currentTab === 'compliance'" />
                        </div>
                    </div>

                    <!-- 배출목표 관리 탭 -->
                    <div v-show="currentTab === 'goal'" class="panel">
                        <div class="panel-body">
                            <GoalManagement :is-active="isActive && currentTab === 'goal'" />
                        </div>
                    </div>

                    <!-- 연도별 이행계획 탭 -->
                    <div v-show="currentTab === 'annual'" class="panel">
                        <div class="panel-body">
                            <AnnualPlanManagement :is-active="isActive && currentTab === 'annual'" />
                        </div>
                    </div>

                    <!-- 부서별 이행계획 탭 -->
                    <div v-show="currentTab === 'departmental'" class="panel">
                        <div class="panel-body">
                            <DepartmentalPlanManagement :is-active="isActive && currentTab === 'departmental'" />
                        </div>
                    </div>
                </template>
            </TabContainer>
        </div>
    </section>
</template>

<script>
import TabContainer from "../../common/TabContainer.vue";
import ComplianceManagement from "../views/ComplianceManagement.vue";
import GoalManagement from "../views/GoalManagement.vue";
import AnnualPlanManagement from "../views/AnnualPlanManagement.vue";
import DepartmentalPlanManagement from "../views/DepartmentalPlanManagement.vue";
import { TARGET_STORAGE_UNIT } from "../targetUnits";
// import ActionManagement from "./components/ActionManagement.vue"; // 부서별 이행계획 탭에서 통합

export default {
    components: {
        TabContainer,
        ComplianceManagement,
        GoalManagement,
        AnnualPlanManagement,
        DepartmentalPlanManagement,
        // ActionManagement,
    },
    props: {
        isActive: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            targetStorageUnit: TARGET_STORAGE_UNIT,
            activeTab: "compliance",
            tabs: [
                { label: "준수기준 관리", value: "compliance" },
                { label: "배출목표 관리", value: "goal" },
                { label: "연도별 이행계획", value: "annual" },
                { label: "부서별 이행계획", value: "departmental" },
            ],
        };
    },
};
</script>

<style scoped>
.target-main {
    display: flex;
    flex-direction: column;
    height: 100%;
    background: #f6f7f9;
}

.target-layout {
    display: grid;
    grid-template-columns: 1fr;
    gap: 6px;
    min-height: 0;
    padding: 0px 16px;
}

.target-unit-notice {
    margin: 0 0 8px;
    padding: 8px 12px;
    font-size: 12px;
    color: #4b5563;
    background: #eff6ff;
    border: 1px solid #bfdbfe;
    border-radius: 8px;
    line-height: 1.5;
}

.target-unit-notice strong {
    color: #1d4ed8;
    font-weight: 600;
}

.panel {
    background: #ffffff;
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    box-shadow: 0 10px 30px rgba(15, 23, 42, 0.04);
    display: flex;
    flex-direction: column;
    min-height: 0;
}

.panel-body {
    flex: 1;
    padding: 0;
    min-height: 0;
}

@media (max-width: 768px) {
    .target-main {
        padding: 16px;
    }
}
</style>
